import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import { DatePicker, ConfigProvider, Space } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getValueFromPath } from "utils";

dayjs.extend(customParseFormat);

const dateFormatList = ["MM/DD/YYYY", "MM/DD/YY", "MM-DD-YYYY", "MM-DD-YY"];
const dateFormatForCard = "MM/YY";

const DatePickerField = ({
  name,
  label,
  placeholder,
  className,
  isRequired = false,
  disabled = false,
  isDynamic = false,
  isCard = false,
  minDate = null,
  maxDate = null,
}) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();

  const showError =
    (isDynamic ? getValueFromPath(errors, name) : errors[name]) &&
    (isDynamic ? getValueFromPath(touched, name) : touched[name]);
  const value = getValueFromPath(values, name);
  const handleDateChange = (date) => {
    if (date && date.isValid()) {
      if (isCard) {
        setFieldValue(name, date.format("MM/YY"));
      } else {
        setFieldValue(name, date.toDate());
      }
    } else {
      setFieldValue(name, "");
    }
  };

  const minDateDayjs = minDate ? dayjs(minDate) : null;
  const maxDateDayjs = maxDate ? dayjs(maxDate) : null;

  return (
    <div className="form-control w-full ">
      {label && (
        <div className="flex items-center gap-1 mb-1">
          <span className="flex gap-1 items-end relative">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
        </div>
      )}

      <ConfigProvider
        theme={{
          token: {
            colorTextPlaceholder: "#979797",
            colorBgContainerDisabled: "#f3f4f6",
            colorTextDisabled: "rgb(148 163 184)",
          },
        }}
      >
        <Space direction="vertical" size={12}>
          <DatePicker
            picker={isCard ? "month" : "date"} // Use month picker for cards
            disabled={disabled}
            onBlur={() => setFieldTouched(name, true)}
            format={isCard ? dateFormatForCard : dateFormatList[2]}
            value={
              isCard
                ? value
                  ? dayjs(value, "MM/YY")
                  : null
                : value
                ? dayjs(value)
                : null
            } // Adjust value format
            onChange={handleDateChange}
            placeholder={placeholder}
            style={{
              width: "100%",
              height: "38px",
            }}
            className={`flex w-full  border border-gray-300 placeholder-gray-300 text-gray-900 rounded-lg focus:outline-none
            dark:bg-slate-950 dark:focus-within:bg-white dark:focus-within:text-black dark:text-gray-300
            ${
              showError
                ? "border focus-within:border-red-500 border-red-500 hover:border-red-500"
                : "border dark:focus-within:border-[#FAB54E]  focus-within:border-[#1996A6] hover:border-gray-300"
            } 
              focus:z-10 sm:text-sm ${className} hover:none`}
              disabledDate={(current) => {
                if (minDateDayjs && current.isBefore(minDateDayjs, "day")) {
                  return true;
                }
                if (maxDateDayjs && current.isAfter(maxDateDayjs, "day")) {
                  return true;
                }
                return false;
              }}
          />
        </Space>
      </ConfigProvider>

      <ErrorMessage
        className="text-xs text-red-500 mt-1"
        name={name}
        component="div"
      />
    </div>
  );
};

export default DatePickerField;
